import React from 'react';
import type { SortOption as SortOptionModel } from '../../@types/ElasticSearchResponse';
import InputRadio from '../../styled-components/components/InputRadio';
import { getOptionDisplayName } from './type-filter-bar';

interface SortOptionProps {
  sortOption: SortOptionModel;
  disabled?: boolean;
  onClick: (query: string) => void;
}

const SortOption = ({ sortOption, disabled, onClick }: SortOptionProps) => (
  <InputRadio
    disabled={disabled}
    checked={sortOption.selected}
    onChange={() => onClick(sortOption.query)}
    id={sortOption.query}
    title={getOptionDisplayName(sortOption.displayName)}
  >
    {getOptionDisplayName(sortOption.displayName)}
  </InputRadio>
);

export default SortOption;
